module.exports = __webpack_public_path__ + "static/media/so.28889c60.svg";